import { G } from "../../constants/theme";

export function BtnG({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: G.green,
        color: G.black,
        fontFamily: "monospace",
        fontSize: 11,
        letterSpacing: 1.5,
        textTransform: "uppercase",
        padding: "14px 32px",
        border: "none",
        cursor: "pointer",
        fontWeight: 700,
        transition: "background .2s",
        flexShrink: 0,
      }}
    >
      {children}
    </button>
  );
}

export function BtnO({ children, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: "transparent",
        color: G.muted,
        fontFamily: "monospace",
        fontSize: 11,
        letterSpacing: 1.5,
        textTransform: "uppercase",
        padding: "14px 32px",
        border: `1px solid ${G.border}`,
        cursor: "pointer",
        flexShrink: 0,
        transition: "all .2s",
      }}
    >
      {children}
    </button>
  );
}
